import React from 'react'
import get from 'lodash/get'
import { Query } from 'react-apollo'
import { i18n } from '../../index'
import Loader from '../../../common/loader/Loader'
import StationPage from '../station/StationPage'
import ActivityDescriptionPage from './ActivityDescriptionPage'
import { fetchStationActivityDescriptions } from '../../activityDescription/activityDescriptionQueries'

function StationActivityDescriptionPage() {
  return (
    <StationPage title={i18n.t('admin.stations.title.activityDescriptions')}>
      {({ station }) => (
        <Query
          query={fetchStationActivityDescriptions}
          variables={{
            stationId: station.id,
          }}
          fetchPolicy='network-only'
        >
          {({ loading, error, data }) => (
            <Loader
              {...{
                loading,
                error,
              }}
            >
              <ActivityDescriptionPage data={get(data, 'stationActivityDescriptions', [])} stationId={station.id} />
            </Loader>
          )}
        </Query>
      )}
    </StationPage>
  )
}

export default StationActivityDescriptionPage
